// Stock simultané des compartiments le long des étapes (même règle que iter_compartment_stock côté serveur).
// Un chargement ajoute ses allocations, une livraison retire les siennes. Une livraison sans allocation
// vide sa commande à sa dernière livraison avant le prochain chargement de cette commande.
const text = (value) => String(value ?? "").trim();
const stepOrderIds = (step) => new Set([step?.order_id, ...(Array.isArray(step?.order_ids) ? step.order_ids : [])].map(text).filter(Boolean));

// Pour chaque chargement ou livraison, dans l'ordre : le stock avant et après l'étape
// (Map compartiment → Map commande → tonnes).
export function compartmentStockByStep(steps = []) {
  const moves = (Array.isArray(steps) ? steps : []).filter((step) => step?.step_type === "loading" || step?.step_type === "delivery");
  const result = [];
  let stock = new Map();
  moves.forEach((step, index) => {
    const before = stock;
    stock = new Map([...before].map(([compartmentId, orders]) => [compartmentId, new Map(orders)]));
    const isLoading = step.step_type === "loading";
    const allocations = (Array.isArray(step.compartment_allocations) ? step.compartment_allocations : [])
      .filter((allocation) => text(allocation?.compartment_id));
    allocations.forEach((allocation) => {
      const compartmentId = text(allocation.compartment_id);
      const orders = stock.get(compartmentId) || new Map();
      const orderId = text(allocation.order_id) || text(step.order_id);
      const quantityTons = Number(allocation.quantity_tons) || 0;
      orders.set(orderId, Math.round(((orders.get(orderId) || 0) + (isLoading ? quantityTons : -quantityTons)) * 1000) / 1000);
      stock.set(compartmentId, orders);
    });
    if (!isLoading && !allocations.length) {
      stepOrderIds(step).forEach((orderId) => {
        const later = moves.slice(index + 1).find((candidate) => stepOrderIds(candidate).has(orderId));
        if (!later || later.step_type === "loading") stock.forEach((orders) => orders.delete(orderId));
      });
    }
    stock.forEach((orders, compartmentId) => {
      orders.forEach((tons, orderId) => { if (tons <= 1e-6) orders.delete(orderId); });
      if (!orders.size) stock.delete(compartmentId);
    });
    result.push({ step, before, after: stock });
  });
  return result;
}

export function sharedCompartmentIdsByStep(steps = []) {
  const sharedByStep = new Map();
  compartmentStockByStep(steps).forEach(({ step, before, after }) => {
    // Chargement : après l'étape; livraison : avant de décharger.
    const source = step.step_type === "loading" ? after : before;
    sharedByStep.set(step, new Set([...source].filter(([, orders]) => orders.size > 1).map(([compartmentId]) => compartmentId)));
  });
  return sharedByStep;
}

// Allocations de l'étape, marquées is_shared quand le compartiment contient plusieurs commandes à ce moment.
export function markSharedCompartmentAllocations(steps = []) {
  const sharedByStep = sharedCompartmentIdsByStep(steps);
  return (Array.isArray(steps) ? steps : []).map((step) => {
    const sharedIds = sharedByStep.get(step);
    if (!sharedIds?.size || !Array.isArray(step.compartment_allocations)) return step;
    return {
      ...step,
      compartment_allocations: step.compartment_allocations.map((allocation) => (
        sharedIds.has(text(allocation?.compartment_id)) ? { ...allocation, is_shared: true } : allocation
      )),
    };
  });
}
